export const headerDefaultFetcher = <TResponse = unknown>(
  key: Array<string> | string,
): Promise<TResponse> =>
  fetch(
    typeof key === 'string' ? key : key[0],
    Array.isArray(key) && key[1] ? { headers: { 'x-ec-token': key[1] } } : {},
  ).then((res) => {
    if (!res.ok) {
      // throw error when response status not ok -> error boundary catches and logs the error
      throw new Error(`Endpoint: ${res.url} - Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

export const createApiUrl = (endpoint: string) =>
  `${typeof window !== 'undefined' ? '' : process.env.SERVER_HOST}${endpoint}`;
